import { useCart } from './useCart';

export const useCartContainsSubscription = () => {
    const { cart } = useCart();

    return cart?.lineItems?.some((lineItem) => lineItem.custom.subscriptionSelection) ?? false;
};
